import React from 'react';
import { translate } from '../utils';

const NoResults = ({ text = translate('NOTHING_FOUND'), className = '' }) => {
  return <div className={`no_results ${className}`}>{text}</div>;
};

export default NoResults;
